// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__reuDv","label-wrapper":"Label_label-wrapper__u1Tyw"};